import { render, staticRenderFns } from "./ComponentDrag.vue?vue&type=template&id=aa5b4e96"
import script from "./ComponentDrag.vue?vue&type=script&lang=js"
export * from "./ComponentDrag.vue?vue&type=script&lang=js"
import style0 from "./ComponentDrag.vue?vue&type=style&index=0&id=aa5b4e96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports